export default __webpack_public_path__ + "static/media/github-light.12995b19.png";